import type { COUPON_TYPE_SEQ, COUPON_TYPE_GROUP } from '@/enums/detail'

import { ResponseDto } from '@/api/server/common/dto'

export class TicketViewParkinglotCoupon {
  couponSeq!: number
  couponName!: string
}

export class TicketViewParkinglot {
  parkinglotSeq!: number
  parkinglotName!: string
  parkinglotAddress!: string
  parkinglotLatitude!: number
  parkinglotLongitude!: number
  coupons!: TicketViewParkinglotCoupon[]
}

export class Ticket {
  couponSeq!: number
  couponName!: string
  couponTypeSeq!: COUPON_TYPE_SEQ
  couponTypeGroup!: COUPON_TYPE_GROUP
  couponTypeName!: string
  price!: number
  isOpen!: boolean
  isSoldOut!: boolean
  usingTimeLabel!: string
  usingDateLabel!: string
  nextTimeLabel!: string
  notice!: string
  notice2!: string
  enteringNotice!: string
  photos!: TicketPhoto[]
  parkinglot!: TicketViewParkinglot
}

export class TicketPhoto {
  fileName!: string
  thumbnail!: string
  width!: number
  height!: number
  pictureDesc!: string | null
}

export class GetTicketDetailPathVar {
  couponSeq!: string
}

export class GetTicketDetailResDto extends ResponseDto {
  data!: Ticket
}

export class GetUserInputTemplatePathVar {
  couponSeq!: string
}
export class GetUserInputTemplateResDto extends ResponseDto {
  data!: {
    userInputTemplate: string | null
  }
}
